import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import {DevTools, FormatSimple, Tolgee, TolgeeProvider, TranslatePropsInternal} from "@tolgee/react";
import {getDebug, getI18n, getLang} from "./Data";
import localeDe from './i18n/de.json';
import localeEn from './i18n/en.json';
import {FormatIcu} from "@tolgee/format-icu";


export const missingKeys = new Map<string, Map<string, string>>();

export const devMode = (document.location.hostname === "localhost" || document.location.hostname === "127.0.0.1" || getDebug());
export const i18nMode = getI18n();

const tolgee = Tolgee()
    .use((i18nMode && devMode) ? DevTools() : undefined)
    .use(FormatSimple())
    .use(FormatIcu())
    .init({
        language: getLang(),
        availableLanguages: ['en', 'de'],
        ...(devMode ?
            {
                apiUrl: process.env.REACT_APP_TOLGEE_API_URL,
                apiKey: process.env.REACT_APP_TOLGEE_API_KEY,
                onTranslationMissing: function (info: TranslatePropsInternal) {
                    const language = tolgee.getLanguage() ?? "none";
                    let missingKeysForLanguage = missingKeys.get(language);

                    if (!missingKeysForLanguage) {
                        missingKeysForLanguage = new Map<string, string>();
                        missingKeys.set(language, missingKeysForLanguage);
                    }

                    let missingKey = missingKeysForLanguage.get(info.key);
                    if (!missingKey) {
                        const variables = "[" + (info.params ? Object.keys(info.params).map(key => "{" + key + "}").join() : "") + "]";
                        if (info.defaultValue) {
                            missingKeysForLanguage.set(info.key, info.defaultValue + variables );
                        } else {
                            missingKeysForLanguage.set(info.key, variables);
                        }
                    }

                    return info.key;
                }
                // ,
                // onFormatError: function (error: string, info: TranslatePropsInternal): string {
                //     return info.translation ?? info.key;
                // }
            } :
            {
                staticData: {
                    en: (i18nMode ? localeEn : {}),
                    de: (i18nMode ? localeDe : {})
                }
            })
    });

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
      <TolgeeProvider
          tolgee={tolgee}
          fallback="Loading..." // loading fallback
      >
        <App />
      </TolgeeProvider>
  </React.StrictMode>
);
